function selectLang() {
    const el = document.getElementById( 'currentLang' );
    const currentUrl = window.location.href;

    // Get localized sites data from PHP
    const localizedSites = window.langSelectLocalizedSites ?? null;

    // Default language
    let selectedLanguage = 'English';

    // Check each localized site
    if ( localizedSites && Array.isArray( localizedSites ) ) {
        localizedSites.every( site => {
            if ( site.url && site.language_abbreviated ) {
                // Extract domain from the site URL
                try {
                    const siteUrl = new URL( site.url );
                    const siteDomain = siteUrl.hostname;

                    // Check if the current URL contains the site domain
                    if ( currentUrl.includes( siteDomain ) ) {
                        // Use language_full for display, fallback to language_abbreviated
                        selectedLanguage = site.language_full || site.language_abbreviated;
                        return false; // Exit the loop once match is found
                    }
                } catch ( error ) {
                    console.warn( 'Invalid URL in localized sites:', site.url );
                }
            }
            return true;
        } );
    }

    // Set the selected language
    if ( el ) {
        el.innerHTML = selectedLanguage;
    }
}

window.selectLang = selectLang;